/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawer_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilters_user" | "SbSharedRefineMenuDisplayPrefsSelect_user">;
    readonly " $refType": "SbRespRefineMenuDrawer_user";
};
export type SbRespRefineMenuDrawer_user$data = SbRespRefineMenuDrawer_user;
export type SbRespRefineMenuDrawer_user$key = {
    readonly " $data"?: SbRespRefineMenuDrawer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuDrawer_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawer_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'c566fbfef78ac8432fecb1da64381063';
export default node;
